import { useRef, useState } from 'react';

type UseCloseConfirmationReturn = {
    showConfirmClose: boolean;
    closeDirectly: (onClose: () => void) => void;
    requestClose: (onClose: () => void) => void;
    handleConfirmClose: () => void;
    handleCancelClose: () => void;
};

const useCloseConfirmation = (): UseCloseConfirmationReturn => {
    const [showConfirmClose, setShowConfirmClose] = useState(false);
    const pendingClose = useRef<(() => void) | null>(null);

    const closeDirectly = (onClose: () => void) => {
        onClose();
    };

    const requestClose = (onClose: () => void) => {
        pendingClose.current = onClose;
        setShowConfirmClose(true);
    };

    const handleConfirmClose = () => {
        setShowConfirmClose(false);
        pendingClose.current?.();
        pendingClose.current = null;
    };

    const handleCancelClose = () => {
        setShowConfirmClose(false);
        pendingClose.current = null;
    };

    return { showConfirmClose, closeDirectly, requestClose, handleConfirmClose, handleCancelClose };
};

export default useCloseConfirmation;
